import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";
import { colors } from "../assets/colors";

export const title: any = {
  fontWeight: "600",
  fontSize: "19px",
  lineHeight: "28px",
  textAlign: "center",
  letterSpacing: "0.4px",
  color: colors.gray,
  opacity: 0.5,
  marginTop: "10px",
};

export const errorMessage = {
  color: "red",
  fontSize: 12,
};

export const forgetPasswordContainer = {
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  marginTop: 10,
  textAlign: "right",
};

export const forgetPassword = {
  color: "#55CFFF",
};

export const subtitleContainer = {
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
};

export const subtitle1 = {
  color: colors.black,
  fontSize: 15,
  fontWeight: 600,
  letterSpacing: "0.3px",
};

export const subtitle2 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: "0.3px",
  color: colors.gray,
};

export const subtitle3 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: "0.3px",
  color: "red",
  width: "70%",
};
